
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"81.035","height":"82.02","viewBox":"0 0 81.035 82.02"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M39.993 82.02a41.023 41.023 0 010-82.02 40.771 40.771 0 0116.7 3.552 3.23 3.23 0 11-2.628 5.9 34.274 34.274 0 00-14.066-3 34.565 34.565 0 000 69.1 34.6 34.6 0 0034.565-34.558v-3.475a3.229 3.229 0 116.458 0v3.475A41.074 41.074 0 0139.993 82.02z"}}),_c('path',{staticClass:"a",attrs:{"d":"M40.006 51.828a3.229 3.229 0 01-2.286-.943L26.385 39.551a3.233 3.233 0 114.572-4.572l9.042 9.042 35.52-35.52a3.229 3.229 0 114.573 4.56L42.311 50.88a3.229 3.229 0 01-2.286.949z"}})])
          )
        }
      }
    